import Text from '@components/Text';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function OrderNotice() {
    const { t } = useTranslation('shopLocation');
    return (
        <Container>
            <Text size='body-long' color='var(--color-text-secondary)' align='center'>
                {t('warning.title')}
                <br/>
                {t('warning.description')}
            </Text>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-white);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    padding: var(--spacing-4);
    width: 100%;
`;

export default OrderNotice;
